export const ru = {
  globals: {},
  auth: {
    emailId: "Электронная почта",
    password: "Пароль",
    remember: "Запомнить меня",
    forgotPassword: "Забыли пароль",
    oldPass: "Старый пароль",
    confmPas: "Подтвердите пароль",
    otpVerification: "Подтверждение OTP",
    verify: "Подтвердить",
    resendOtp: "Отправить OTP снова",
    login: "Войти",
    resendPass: "Сбросить пароль",
    editProfile: "Редактировать профиль",
    firstName: "Имя",
    lastName: "Фамилия",
    email: "Электронная почта",
    phone: "Номер телефона",
    dontHave: "Нет аккаунта?",
    signUp: "Зарегистрироваться",
    already: "Уже есть аккаунт?",
    enterOtp: "Введите OTP",
    otpSentTo: "4-значный OTP был отправлен на",
    codeExpire: "код истечёт через",
    logout: "Вы уверены, что хотите выйти?",
  },
  main: {
    productNameEn: "Название продукта (английский)",
    productNameAr: "Название продукта (арабский)",
    productNameRu: "Название продукта (русский)",
    gradeEn: "Класс (английский)",
    gradeAr: "Класс (арабский)",
    gradeRu: "Класс (русский)",
    modelEn: "Модель № (английский)",
    modelAr: "Модель № (арабский)",
    modelRu: "Модель № (русский)",
    images: "Изображения",
    editProduct: "Редактировать продукт",
    addProduct: "Добавить продукт",
    deliveryInformation: "Информация о доставке",
    instructions: "Инструкции",
    orderSummary: "Сводка заказа",
    orderItems: "Товары в заказе",
    total: "Итого",
    item: "Товар",
    orderDetails: "Детали заказа",
    productDesc: "Описание продукта",
    productType: "Тип продукта",
    shelfLife: "Срок хранения",
    modalNumber: "Номер модели",
    grade: "Класс",
    placeOfOrigin: "Место происхождения",
    quantity: "Количество",
    back: "Назад",
    productDetails: "Детали продукта",
    list: "Список",
    addFaq: "Добавить FAQ",
    answer: "Ответ",
    question: "Вопрос",
    arabic: "Арабский",
    english: "Английский",
    russian: "Русский",
    selectLang: "Выберите язык",
    addFaq: "Добавить новый FAQ",
    generalSettings: "Общие настройки",
    faqs: "Часто задаваемые вопросы",
    query: "Запрос",
    revertToQuery: "Вернуться к запросу",
    averageDeliveryTime: "Среднее время доставки (в днях)",
    responseTime: "Время ответа (в часах)",
    helpAndSupport: "Помощь и поддержка",
    profileInfo: "Информация профиля",
    broadcast: "Трансляция",
    select: "Выбрать",
    notificationType: "Тип уведомления",
    sendNotification: "Отправить уведомление",
    addNotification: "Добавить уведомление",
    notificationTable: "Таблица уведомлений",
    averageFeedback: "Средняя оценка",
    repeatCustomers: "Постоянные клиенты",
    respond: "Ответить",
    review: "Обзор",
    customer: "Клиент",
    ratings: "Оценки и отзывы",
    typeMessage: "Введите ваше сообщение...",
    percentage: "Процент",
    addDiscount: "Добавить скидку",
    discountTable: "Таблица скидок",
    amount: "Сумма",
    orderNumber: "Номер заказа",
    withdraw: "Вывести платежи",
    paymentHistory: "История платежей",
    extraPaymentByUser: "Дополнительный платеж от пользователя",
    setRefund: "Назначить возврат",
    setRefundAmount: "Установить сумму возврата",
    exchange: "Обмен",
    return: "Возврат",
    returnTable: "Таблица возвратов и обменов",
    quotesTable: "Таблица предложений",
    cancelled: "Отменено",
    selectDateRange: "Выберите диапазон дат",
    ordersTable: "Таблица заказов",
    send: "Отправить",
    selectProduct: "Выбрать продукт",
    timeFrame: "Промежуток времени (часы)",
    sendQuotation: "Отправить предложение",
    accepted: "Принято",
    addProducts: "Добавить продукты",
    availableStock: "Доступный запас",
    quantityPerUnit: "Количество на единицу",
    pricePerUnit: "Цена за единицу",
    productsTable: "Таблица продуктов",
    rating: "Рейтинг",
    quantitySold: "Продано единиц",
    products: "Продукты",
    bestSelling: "Хиты продаж",
    monthlySales: "Ежемесячные продажи",
    commissionPaid: "Выплаченная комиссия",
    revenue: "Доход",
    newOrders: "Новые заказы",
    pendingQuotes: "Ожидающие предложения",
    totalCustomers: "Всего клиентов",
    totalVendors: "Всего поставщиков",
    totalOrders: "Текущие заказы",
    completedOrders: "Завершенные заказы",
    cancelledOrders: "Отмененные заказы",
    totalCategories: "Всего категорий",
    totalSubCategories: "Всего подкатегорий",
    totalRevenue: "Общий доход",
    totalProductsListed: "Всего размещенных продуктов",
    exportCsv: "Экспорт в CSV",
    sNo: "№",
    image: "Изображение",
    fullName: "Полное имя",
    phoneNumber: "Номер телефона",
    email: "Электронная почта",
    businessName: "Название компании",
    industryType: "Тип отрасли",
    address: "Адрес",
    manageAccount: "Управление аккаунтом",
    reject: "Отклонить",
    accept: "Принять",
    pending: "В ожидании",
    approved: "Одобрено",
    rejected: "Отклонено",
    deactivate: "Деактивировано",
    search: "Поиск здесь",
    accountStatus: "Статус аккаунта",
    actions: "Действия",
    name: "Имя",
    subCategory: "Подкатегория",
    addCategory: "Добавить категорию",
    viewSubCategories: "Просмотр подкатегорий",
    selectCategory: "Выберите категорию",
    selectSubCategory: "Выберите подкатегорию",
    clearFilter: "Очистить фильтр",
    addProduct: "Добавить продукт",
    productName: "Название продукта",
    vendorName: "Имя поставщика",
    subCategoryName: "Название подкатегории",
    parentCategory: "Родительская категория",
    manageProduct: "Управление продуктом",
    status: "Статус",
    todayDeals: "Предложения дня",
    bestDeals: "Лучшие предложения",
    customerName: "Имя клиента",
    inProgress: "В процессе",
    category: "Категория",
    productQuantity: "Количество продукта",
    price: "Цена",
    specificReq: "Особые требования",
    chat: "Чат",
    quoteStatus: "Статус предложения",
    sendQuote: "Отправить предложение",
    deliveryConditions: "Условия доставки",
    shippingCharge: "Стоимость доставки",
    freeDelivery: "Бесплатная доставка",
    payment: "Платеж",
    refundable: "Возврат возможен",
    nonRefundable: "Без возврата",
    update: "Обновить",
    cancel: "Отменить",
    orderId: "Номер заказа",
    date: "Дата",
    refundAmount: "Сумма возврата",
    amountSetByVendor: "Сумма, установленная поставщиком",
    refund: "Возврат",
    refundPayment: "Возврат платежа",
    addBanner: "Добавить баннер",
    banner: "Баннер",
    discountName: "Название скидки",
    discountPercentage: "Процент скидки",
    description: "Описание",
    type: "Тип",
    bannerType: "Тип баннера",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    addDiscount: "Добавить скидку",
    onGoing: "В процессе",
    completed: "Завершено",
    orderTrackId: "ID отслеживания заказа",
    userName: "Имя пользователя",
    subTotal: "Промежуточный итог",
    totalCost: "Общая стоимость",
    deliveryFees: "Плата за доставку",
    shippingAddress: "Адрес доставки",
    contact: "Контакт",
    orderStatus: "Статус заказа",
    paymentStatus: "Статус платежа",
    orderPlaced: "Заказ оформлен",
    shipping: "Доставка",
    delivered: "Доставлено",
    extraAmountPay: "Дополнительная сумма к оплате",
    totalCostPay: "Общая сумма к оплате",
    acceptReject: "Принять/Отклонить",
    inbox: "Входящие",
    totalPayments: "Общие платежи",
    pendingPayments: "Ожидающие платежи",
    amountPaidToVendor: "Сумма, выплаченная поставщику",
    makePayment: "Совершить платеж",
    pay: "Оплатить",
    addNotification: "Добавить уведомление",
    sentTo: "Отправлено кому",
    title: "Заголовок",
    messages: "Сообщения",
    delete: "Удалить",
    addSubAdmin: "Добавить суб-администратора",
    role: "Роль",
    add: "Добавить",
    platformCommission: "Комиссия платформы",
    tax: "Налог",
    responseTime: "Время ответа (часы)",
    avgDeliveryTime: "Среднее время доставки (дни)",
    save: "Сохранить",
    orderCancellationTime: "Время отмены заказа (часы)",
    orderExchangeTime: "Время обмена заказа (дни)",
    serviceFee: "Плата за обслуживание",
    general: "Общие",
    timing: "Время",
    contactSupport: "Связаться с поддержкой",
    privacyPolicy: "Политика конфиденциальности",
    agreement: "Соглашение",
    terms: "Условия и положения",
    cookiesPolicy: "Политика использования файлов cookie",
    about: "О нас",
    dataDeletion: "Политика удаления данных",
    conversionRate: "Курс обмена",
    conversionUsdToAed: "Курс обмена USD на AED",
    shelfEn: "Срок хранения (английский)",
    shelfAr: "Срок хранения (арабский)",
    shelfRu: "Срок хранения (русский)",
    styleEn: "Стиль (английский)",
    styleAr: "Стиль (арабский)",
    styleRu: "Стиль (на русском)",
    productTypeEn: "Тип продукта (на английском)",
    producTypeAr: "Тип продукта (на арабском)",
    productTypeRu: "Тип продукта (на русском)",
    placeOfOrigin: "Страна происхождения",
    stock: "Доступное количество",
    priceUnit: "Цена за единицу",
    select: "Выбрать",
    makeAsPackage: "Создать как пакет",
    quantityPerUnit: "Количество в единице",
    pricePerUnit: "Цена за единицу",
    minPerchaseQty: "Минимальное количество для покупки (в единицах)",
    descEng: "Описание (на английском)",
    descAr: "Описание (на арабском)",
    descRu: "Описание (на русском)",
    bulkPricing: "Оптовое ценообразование",
    minQty: "Минимальное количество",
    maxQty: "Максимальное количество",
    remove: "Удалить",
    addBulk: "Добавить оптовую цену",
    pricePerKg: "Цена за кг",
    pricePerLiter: "Цена за литр",
    minQtyKg: "Минимальное количество для покупки (в кг)",
    minQtyLiter: "Минимальное количество для покупки (в литрах)",
    selectDateRange: "Выбрать диапазон дат",
    quotedSubmitted: "Коммерческое предложение отправлено",
    quoteNotSubmitted: "Коммерческое предложение не отправлено",
    editBanner: "Редактировать баннер",
    createBannerFor: "Создать баннер для",
    discountNameEn: "Название скидки на английском",
    discountNameAr: "Название скидки на арабском",
    discountNameRu: "Название скидки на русском",
    discountPer: "Процент скидки",
    addBannerImage: "Добавить изображение баннера",
    orderDetails: "Детали заказа",
    customerDetails: "Данные клиента",
    productsOrdered: "Заказанные товары",
    regNo: "Регистрационный номер",
    orderedQty: "Заказанное количество",
    myProfile: "Мой профиль",
    changePassword: "Сменить пароль",
    logout: "Выйти",
    currentPass: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPass: "Подтвердите пароль",
    daily: "Ежедневно",
    weekly: "Еженедельно",
    monthly: "Ежемесячно",
    yearly: "Ежегодно",
    orders: "Заказы",
    sales: "Продажи",
    overView: "Обзор",
    signToSura: "Войти в Sura Trade",
    createAccount: "Создать аккаунт",
    agree: "Согласен с соглашением Sura Trade",
    profileSetup: "Настройка профиля",
    pinCode: "Почтовый индекс",
    city: "Город",
    phoneOpt: "Номер телефона (необязательно)",
    bankDetails: "Банковские реквизиты",
    bankName: "Название банка",
    bankBranch: "Филиал банка",
    holder: "Имя владельца счёта",
    accNumber: "Номер счёта",
    swift: "SWIFT-код",
    passSetup: "Настройка пароля",
    enterPass: "Введите пароль",
    reEnterPAss: "Повторите пароль",
    businessReq: "Регистрация бизнеса",
    confirmNewPass: "Подтвердите новый пароль",
    submit: "Отправить",
    productAdded: "Товар успешно добавлен",
    productUpdated: "Товар успешно обновлён",
    aggrement: "Торговое соглашение Sura",
    retailer: "Розничный продавец",
    wholeSaler: "Оптовик",
    distributor: "Дистрибьютор",
    yes: "Да",
    no: "Нет",
    checkNewMessage: "Проверьте новые сообщения",
    product: "Товар",
    discountUpdated: "Скидка успешно обновлена",
    discountAdded: "Скидка успешно добавлена",
    editDiscount: "Редактировать скидку",
    discountNameEn: "Название скидки (английский)",
    discountNameAr: "Название скидки (арабский)",
    discountNameRu: "Название скидки (русский)",
    descEng: "Описание (английский)",
    descAr: "Описание (арабский)",
    descRu: "Описание (русский)",
    startTime: "Время начала",
    endTime: "Время окончания",
    cmsUpdated: "CMS успешно обновлён",
    aboutUs: "О нас",
    terms: "Условия и положения",
    privacy: "Политика конфиденциальности",
    profileCreated:
      "Профиль успешно создан! Пожалуйста, подождите, пока администратор одобрит ваш профиль",
    profileUpdate: "Профиль успешно обновлён",
    downloadPdf: "Нажмите, чтобы скачать PDF",
  },

  dashboard: {},

  error: {
    required: "Это поле обязательно для заполнения",
    validation1: "Пожалуйста, выберите правильное видео",
    maxValidation: "Максимум разрешено 80 символов",
    minValidation: "Минимум 3 символа",
    noData: "Результатов не найдено",
    titlereq: "Заголовок обязателен",
    descReq: "Описание обязательно",
    noFaq: "Список часто задаваемых вопросов не найден",
    emailReq: "Электронная почта обязательна!",
    validEmail: "Введите правильный адрес электронной почты!",
    firstReq: "Имя обязательно",
    lastReq: "Фамилия обязательна",
    phoneReq: "Номер телефона обязателен",
    minPhone: "Номер телефона должен содержать хотя бы 6 цифр",
    maxPhone: "Номер телефона должен содержать хотя бы 16 цифр",
    subAdminCreated: "Суб-администратор успешно создан",
    subAdminUpdate: "Суб-администратор успешно обновлен",
    userUpdate: "Пользователь успешно обновлен",
    statusUpdate: "Статус успешно обновлен",
    subAdminDel: "Суб-администратор успешно удален",
    userDel: "Пользователь успешно удален",
    max100: "Максимум разрешено 100 символов",
    max250: "Максимум разрешено 250 символов",
    max500: "Максимум разрешено 500 символов",
    catAdd: "Категория успешно добавлена",
    catUpdate: "Категория успешно обновлена",
    settingUpdate: "Настройки успешно обновлены",
    faqAdd: "FAQ успешно добавлен",
    faqDel: "FAQ успешно удален",
    cmsUpdate: "CMS успешно обновлен",
    messageReq: "Сообщение обязательно",
    notiAdd: "Уведомление успешно добавлено",
    notiDel: "Уведомление успешно удалено",
    logutReq: "Вы уверены, что хотите выйти?",
    noUserFound: "Пользователь не найден",
    noVendorFound: "Поставщик не найден",
    noSubFound: "Подкатегория не найдена",
    noChatFound: "Чаты не найдены",
    categoryReq: "Категория обязательна",
    subCategoryReq: "Подкатегория обязательна",
    passReq: "Пароль обязателен",
    passValid:
      "Пароль должен содержать не менее 8 символов, одну заглавную букву, одну строчную букву, одну цифру и один специальный символ.",
    passMatch: "Пароли должны совпадать.",
    min6: "Требуется минимум 6 символов",
    passNotMatch: "Пароли не совпадают",
    confirmPassReq: "Требуется подтверждение пароля",
    agreeTo: "Пожалуйста, сначала согласитесь с условиями",
    uploadImage: "Пожалуйста, загрузите изображения",
    docReq: "Требуются документы",
    areYouSure: "Вы уверены, что хотите удалить это?",
    uploadBanner: "Пожалуйста, загрузите изображение для баннера",
    addSettings: "Пожалуйста, сначала добавьте общие настройки",
  },
  messages: {},
};
